import gql from "graphql-tag";

export function linesOfBusinessListQuery(params) {
    return {
        query: gql`
            query($searchText: String) {
                result: lineOfBusiness(searchText: $searchText) {
                    id
                    name
                }
            }
        `,
        variables: params,
    };
}
